import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { MapComponent } from './map.component';

export const mapRoutes: Routes = [
    {
        path: 'map',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'MAP_DASHBOARD',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: MapComponent },
        ]
    }
];
